import {TradingAccountAccessModel, UserRelationTypesEnum} from '@spa/api';

import {Helper} from '../../../shared/classes';
import {FeatureEnum, PermissionsEnum, PortalPermissionsEnum} from '../../../shared/enums';

/**
 * Where and to whom the access-rights UI offers the Public Portfolio Publishing right.
 * The right can be granted only on the account owner's access row of a trading account; the backend
 * refuses every other grant with 400 and refuses any change while Public Traders is switched off with 409.
 * Only holders of the rights-administration permission may change it.
 */
export class PublishPortfolioRightRule {
    /** The same set the backend's grant guard accepts: the exact right and its two wildcards. */
    private static readonly managePermissions: string[] = [
        PermissionsEnum.CrmUsersUpdateRights,
        PermissionsEnum.CrmUsersAll,
        PermissionsEnum.CrmAllAll
    ];

    static isPublishRight(permissionString: string): boolean {
        return permissionString === PortalPermissionsEnum.TradingAccountsPublishPortfolio;
    }

    static isFeatureOn(): boolean {
        return Helper.isFeatureEnabled(FeatureEnum.PublicTraders);
    }

    /**
     * The checkbox is offered on the owner's trading account row while the feature is on: an individual
     * client's row that the backend does not mark as somebody else's (isOwner null = the response carries
     * no owner flag yet and counts as unknown, not as "not the owner"). A row that already carries the
     * right keeps its checkbox so the right stays revocable.
     */
    static isOfferedOnRow(accessRight: TradingAccountAccessModel, userRelationType: number, publishRightId: number): boolean {
        if (!PublishPortfolioRightRule.isFeatureOn() || accessRight.isCashAccount) {
            return false;
        }

        if (accessRight.permissionIds.indexOf(publishRightId) >= 0) {
            return true;
        }

        return userRelationType === UserRelationTypesEnum.Individual && accessRight.isOwner !== false;
    }

    static canManage(userPermissions: string[]): boolean {
        return Helper.getUnionStrategyPermissionsCheck(PublishPortfolioRightRule.managePermissions, userPermissions || []);
    }
}
